export enum WorkFlowTaskToDoType {
  WAIT_SIGN = 'WAIT_SIGN',
  WAIT_EDIT = 'WAIT_EDIT',
  IN_PROGRESS = 'IN_PROGRESS',
  WAIT_COUNTER_SIGN = 'WAIT_COUNTER_SIGN',
  WAIT_REPLY = 'WAIT_REPLY',
  WAITING = 'WAITING',
  DONE = 'DONE',
  WAIT_READ = 'WAIT_READ',
  READ = 'READ',
  MESSAGE_NOTICE = 'MESSAGE_NOTICE',
  MESSAGE_TASK = 'MESSAGE_TASK',
}

export const WorkFlowTaskToDoTypeMap = {
  [WorkFlowTaskToDoType.WAIT_SIGN]: '待签',
  [WorkFlowTaskToDoType.WAIT_EDIT]: '待改',
  [WorkFlowTaskToDoType.WAIT_REPLY]: '待回',
  [WorkFlowTaskToDoType.WAIT_COUNTER_SIGN]: '发起会签',
  [WorkFlowTaskToDoType.WAIT_READ]: '待阅',
  [WorkFlowTaskToDoType.WAITING]: '等待',
  [WorkFlowTaskToDoType.DONE]: '已办',
  [WorkFlowTaskToDoType.READ]: '已阅',
  [WorkFlowTaskToDoType.MESSAGE_NOTICE]: '通知',
  [WorkFlowTaskToDoType.MESSAGE_TASK]: '任务',
  [WorkFlowTaskToDoType.IN_PROGRESS]: '流程中',
};
